/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection11FoiChanged, m11ReportSection11ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection11Foi, selectM11ReportSection11Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import CodeEntry from "../../datatypeComponents/CodeEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialOversightChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section11State, setAlertModalState, setStartingSection11State) => {

    let changesStates = {
        section11State: section11State
    };
    let response = await saveM11Changes(apiToken, 35, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection11Resource) {
            dispatch(m11ReportSection11ResourceChanged(response.m11ReportSection11Resource));
        }
        setStartingSection11State(JSON.parse(JSON.stringify(section11State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step035TrialOversightPart1 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection11Foi = useSelector(selectM11ReportSection11Foi);
    const m11ReportSection11Resource = useSelector(selectM11ReportSection11Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section11State, setSection11State] = useState({
        "section111Status": "generated", "section111Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>This trial will be conducted in accordance with the protocol and with the following: </p><p>• Ethical principles that have their origin in the Declaration of Helsinki for medical research involving human subjects </p><p>• Consensus ethical principles derived from international guidelines including the Declaration of Helsinki and the Council for International Organisations of Medical Sciences (CIOMS) International Ethical Guidelines </p><p>• ICH Good Clinical Practice (GCP) Guidelines </p><p>• Applicable laws and regulations</p></div>',
        "lumpOrSplit": "",
        "section112Status": "empty", "section112Xhtml": "",
        "section1121Status": "empty", "section1121Xhtml": "",
        "section1122Status": "empty", "section1122Xhtml": ""
    });
    const [startingSection11State, setStartingSection11State] = useState({
        "section111Status": "generated", "section111Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>This trial will be conducted in accordance with the protocol and with the following: </p><p>• Ethical principles that have their origin in the Declaration of Helsinki for medical research involving human subjects </p><p>• Consensus ethical principles derived from international guidelines including the Declaration of Helsinki and the Council for International Organisations of Medical Sciences (CIOMS) International Ethical Guidelines </p><p>• ICH Good Clinical Practice (GCP) Guidelines </p><p>• Applicable laws and regulations</p></div>',
        "lumpOrSplit": "",
        "section112Status": "empty", "section112Xhtml": "",
        "section1121Status": "empty", "section1121Xhtml": "",
        "section1122Status": "empty", "section1122Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section11State, startingSection11State)),
        async saveAllChanges() {
            await saveTrialOversightChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section11State, setAlertModalState, setStartingSection11State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section111Status": "generated", "section111Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>This trial will be conducted in accordance with the protocol and with the following: </p><p>• Ethical principles that have their origin in the Declaration of Helsinki for medical research involving human subjects </p><p>• Consensus ethical principles derived from international guidelines including the Declaration of Helsinki and the Council for International Organisations of Medical Sciences (CIOMS) International Ethical Guidelines </p><p>• ICH Good Clinical Practice (GCP) Guidelines </p><p>• Applicable laws and regulations</p></div>',
                "lumpOrSplit": "",
                "section112Status": "empty", "section112Xhtml": "",
                "section1121Status": "empty", "section1121Xhtml": "",
                "section1122Status": "empty", "section1122Xhtml": "",
                "loaded": true
            };
            setSection11State(startingData);
            setStartingSection11State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[11]?.entry?.length) {
                let m11ReportSection011Foi = getIdFromReference(m11ReportContainerResource.section[11].entry[0]);
                if (m11ReportSection011Foi && !isNaN(m11ReportSection011Foi) &&
                    m11ReportSection011Foi !== m11ReportSection11Foi) {
                    dispatch(m11ReportSection11FoiChanged(m11ReportSection011Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection11Foi && !isNaN(m11ReportSection11Foi)) {
            loadResource(m11ReportSection11Foi, "M11ReportSection11", apiToken, dispatch);
        }
    }, [m11ReportSection11Foi]);

    useEffect(() => {
        if (m11ReportSection11Resource && Object.keys(m11ReportSection11Resource).length > 0) {
            let startingData = {
                "section111Status": "generated", "section111Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>This trial will be conducted in accordance with the protocol and with the following: </p><p>• Ethical principles that have their origin in the Declaration of Helsinki for medical research involving human subjects </p><p>• Consensus ethical principles derived from international guidelines including the Declaration of Helsinki and the Council for International Organisations of Medical Sciences (CIOMS) International Ethical Guidelines </p><p>• ICH Good Clinical Practice (GCP) Guidelines </p><p>• Applicable laws and regulations</p></div>',
                "lumpOrSplit": "",
                "section112Status": "empty", "section112Xhtml": "",
                "section1121Status": "empty", "section1121Xhtml": "",
                "section1122Status": "empty", "section1122Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection11Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection11Resource.section[0].section[0]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[0].text.status !== "empty") {
                    startingData.section111Status = m11ReportSection11Resource.section[0].section[0].text.status;
                    startingData.section111Xhtml = m11ReportSection11Resource.section[0].section[0].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section112Status = m11ReportSection11Resource.section[0].section[1].text.status;
                    startingData.section112Xhtml = m11ReportSection11Resource.section[0].section[1].text.div;
                    startingData.lumpOrSplit = "Lump";
                }
                if (m11ReportSection11Resource.section[0].section[1]?.section?.length > 0) {
                    if (m11ReportSection11Resource.section[0].section[1].section[0]?.text?.div &&
                        m11ReportSection11Resource.section[0].section[1].section[0].text.status !== "empty") {
                        startingData.section1121Status = m11ReportSection11Resource.section[0].section[1].section[0].text.status;
                        startingData.section1121Xhtml = m11ReportSection11Resource.section[0].section[1].section[0].text.div;
                    }
                    if (m11ReportSection11Resource.section[0].section[1].section[1]?.text?.div &&
                        m11ReportSection11Resource.section[0].section[1].section[1].text.status !== "empty") {
                        startingData.section1122Status = m11ReportSection11Resource.section[0].section[1].section[1].text.status;
                        startingData.section1122Xhtml = m11ReportSection11Resource.section[0].section[1].section[1].text.div;
                    }
                }
                setSection11State(startingData);
                setStartingSection11State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection11Resource]);

    return <div>
        <h3>Start Section 11 Trial Oversight and Other General Considerations</h3>
        {!(m11ReportSection11Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 35 (Start Section 11 Trial Oversight and Other General Considerations) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section11State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.1 Regulatory and Ethical Considerations summary as needed.</h4>
                    <TextDivEntry elementName="section111Xhtml"
                        startingValue={section11State.section111Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.2 Trial Oversight summary as needed.</h4>
                    {section11State.lumpOrSplit === "Lump" ?
                        <TextDivEntry elementName="section112Xhtml"
                            startingValue={section11State.section112Xhtml}
                            setResourceState={setSection11State} />
                        :
                        section11State.lumpOrSplit === "Split" ?
                            <>
                                <h5 style={{ marginBottom: "0px" }}>Revise Section 11.2.1 Investigator Responsibilities as needed.</h5>
                                <TextDivEntry elementName="section1121Xhtml"
                                    startingValue={section11State.section1121Xhtml}
                                    setResourceState={setSection11State} />
                                <h5 style={{ marginBottom: "0px" }}>Revise Section 11.2.2 Sponsor Responsibilities as needed.</h5>
                                <TextDivEntry elementName="section1122Xhtml"
                                    startingValue={section11State.section1122Xhtml}
                                    setResourceState={setSection11State} />
                            </>
                            :
                            <>
                                <h5 style={{ marginBottom: "0px" }}>DECIDE whether to summarize as one section (Lump) or 2 subsections (Split).</h5>
                                <CodeEntry elementName='lumpOrSplit' fieldLabel='Lump or Split'
                                    startingValue={section11State.lumpOrSplit} setResourceState={setSection11State}
                                    allowedValues={["Lump", "Split"]} />
                            </>
                    }
                </>}
            </>
        }
    </div >
});

const M11Step035TrialOversightPart1HelperText = <div>
    <h3>Start Section 11 Trial Oversight and Other General Considerations</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 11.1 Regulatory and Ethical Considerations.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Provide a high-level statement on the prevailing ethical, legal, and regulatory guidelines that will be applied throughout the trial.</p>
        </div>
        <p>Enter data for Section 11.2 Trial Oversight.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Concisely summarise the trial oversight, listing the investigator and sponsor responsibilities not covered in other sections of the protocol that are essential for trial conduct, specifying the ones related to quality assurance.</p>
            <p>This section may be structured under one single heading 11.2 Trial Oversight, or under 2 subheadings as 11.2.1 Investigator Responsibilities and 11.2.2 Sponsor Responsibilities.</p>
            <p>DECIDE WHETHER TO USE 1 SECTION OR 2 SUBSECTIONS.  If using 1 section, enter the entire summary there and 'Save All Changes'.</p>
            <p>For Section 11.2.1 Investigator Responsibilities:</p>
            <div style={{ marginLeft: "24px" }} >
                <p>Describe the investigator responsibilities, including the oversight of trial-related activities delegated to a third party that may impact the trial conduct at sites, if applicable and if not addressed elsewhere.</p>
            </div>
            <p>For Section 11.2.2 Sponsor Responsibilities:</p>
            <div style={{ marginLeft: "24px" }} >
                <p>Describe the sponsor responsibilities, including activities to be transferred to a third party that may impact the investigator sites, if applicable.</p>
            </div>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step035TrialOversightPart1ValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 35, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 35 (Start Section 11 Trial Oversight and Other General Considerations) {validationCheckState.step35numberOfChecks} issues checked. {validationCheckState.step35numberPassed} passed. {validationCheckState.step35numberFailed} failed.</h4>
        <p>Section 11.1 heading is 'Regulatory and Ethical Considerations': {validationCheckState.resultCheckSection111Heading}</p>
        <p>Section 11.1 Regulatory and Ethical Considerations has content: {validationCheckState.resultCheckSection111Content}</p>
        <p>Section 11.2 heading is 'Trial Oversight': {validationCheckState.resultCheckSection112Heading}</p>
        <p>Section 11.2 Trial Oversight has content or subheadings: {validationCheckState.resultCheckSection112Content}</p>
        <p>If present, Section 11.2.1 heading is 'Investigator Responsibilities': {validationCheckState.resultCheckSection1121Heading}</p>
        <p>If present, Section 11.2.1 Investigator Responsibilities has content: {validationCheckState.resultCheckSection1121Content}</p>
        <p>If present, Section 11.2.2 heading is 'Sponsor Responsibilities': {validationCheckState.resultCheckSection1122Heading}</p>
        <p>If present, Section 11.2.2 Sponsor Responsibilities has content: {validationCheckState.resultCheckSection1122Content}</p>
    </div>}  </div>
}

export default M11Step035TrialOversightPart1;
export { M11Step035TrialOversightPart1HelperText, M11Step035TrialOversightPart1ValidationCheck };